export enum DocumentAnalysisModelEnum {
  proof_of_address = 'proof_of_address',
  iban = 'iban',
  registration_certificate = 'registration_certificate',
}
